import React from "react";
import Typography from "src/components/Typography";
import classes from "./styles.module.scss";

const FAQBox: React.FC = () => (
  <div className={classes.faqBox}>
    <Typography variant="p20" fontWeight="bold" className={classes.faqTitle}>
      FAQ
    </Typography>
    <Typography variant="p16" className={classes.faqQuestion}>
      Q: Does Unit 5 perform Asbestos Testing?
    </Typography>
    <Typography variant="p16" className={classes.faqAnswer}>
      A: No. Unit 5 does not perform asbestos testing and the staff will not
      handle asbestos materials - any suspected samples will be destroyed and
      will not be shipped anywhere.
    </Typography>
  </div>
);

export default FAQBox;
